import React, { useState, useEffect, useCallback } from "react";
import { useEyeconxStore } from "../../../../store/eyeconxStore";
import patientService from "../../../../services/patient.service";
import { useParams } from "react-router-dom";
import SubHeader from "../../../layout/components/SubHeader";
import PatientInfoCard from "./PatientInfoCard";
import PatientTabs from "./PatientTabs";
import Loading from "../../../common/Loading";

function Patient() {
  const [loading, setLoading] = useState(false);
  const [patientInfo, setPatientInfo] = useState(null);

  const clinicId = useEyeconxStore((state) => state.user.clinicId);
  const { patientId } = useParams();

  const getPatientInfo = useCallback(async () => {
    try {
      const res = await patientService.getPatientById(clinicId, patientId);
      setPatientInfo(res.data);
    } catch (error) {
      console.error("Error fetching patient:", error);
    } finally {
      setLoading(false);
    }
  }, [clinicId, patientId]);

  useEffect(() => {
    setLoading(true);
    getPatientInfo();
  }, [getPatientInfo]);

  return (
    <>
      <SubHeader
        title="Patient Details"
        description="Patient Details Page and Communication"
      />

      {loading && <Loading />}

      {patientInfo && <PatientInfoCard patient={patientInfo} />}
      {patientInfo && <PatientTabs patient={patientInfo} />}
    </>
  );
}

export default Patient;
